import {
  Card,
  CardContent,
  Typography,
  List,
  ListItem,
  Box,
} from "@mui/material";
import useDarkMode from "./useDarkMode";
import { Helmet } from "react-helmet-async";

const AdminReports = () => {
  useDarkMode();
  return (
    <>
      <Helmet>
        <title>AKAAL KIDS - Admin Panel | Reports</title>
      </Helmet>
      <Box
        sx={{
          mt: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
        }}
      >
        <Card sx={{ maxWidth: 500, width: "100%", boxShadow: 3 }}>
          <CardContent>
            <Typography variant="h4" gutterBottom>
              Reports
            </Typography>
            <Typography variant="body1" color="text.secondary" gutterBottom>
              Access and review system and user reports. Use this section to
              monitor activity, performance, and issues.
            </Typography>
            <List>
              <ListItem>View recent reports</ListItem>
              <ListItem>Download report data</ListItem>
              <ListItem>Filter by date or type</ListItem>
            </List>
          </CardContent>
        </Card>
      </Box>
    </>
  );
};

export default AdminReports;
